<template>
	<v-form
		ref="form"
		v-model="valid"
		@submit.prevent="submit"
	>
		<v-layout
			row
			wrap
			ma-0
			justify-center
			align-center
		>
			<v-flex
				xs12
				sm9
				py-0
			>
				<v-text-field
					v-model="name"
					:rules="[...validate.require, validate.max(name, 150)]"
					:required="true"
					autofocus
					name="Name"
					label="Category Name"
				/>
			</v-flex>
			<v-flex
				xs12
				sm3
				class="text-xs-center"
			>
				<v-btn
					:disabled="!valid"
					ripple
					color="primary"
					type="submit"
				>
					Submit
				</v-btn>
				<slot name="buttons"/>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
import Validation from '@/mixins/Validation';
import { Category } from '@/models/Category';

export default {
	mixins: [Validation],
	props: {
		editCategory: { type: Object, default: null },
		existingCategories: { type: Array, default: () => [] },
		archivedCategories: { type: Array, default: () => [] },
	},
	data() {
		return {
			valid: true,
			name: '',
		};
	},
	created() {
		if (this.editCategory) {
			this.name = this.editCategory.name;
		}
	},
	methods: {
		submit() {
			this.valid = false;
			if (this.editCategory) {
				this.updateCategory(this.editCategory);
			}
			else {
				this.newCategory();
			}
		},
		updateCategory(cat) {
			const category = new Category();
			category.name = this.name;
			category.id = cat.id;
			category.save().then(() => {
				const categories = this.$store.get('categories');
				for (let i = 0; i < categories.length; i++) {
					if (categories[i].id === cat.id) {
						categories[i].name = category.name;
					}
				}
				this.$emit('update', category);
				this.$notify('success', `Category ${category.name} has been updated.`);
			}).catch(() => {
				this.$notify('error', `Failed to update category ${cat.name}.`);
			});
		},
		newCategory() {
			const category = new Category();
			const categories = this.$store.get('categories');
			category.name = this.name;
			category.set('projectId', this.$store.get('projects/currentProject').id);
			category.save().then(() => {
				categories.unshift({ id: category.id, name: category.name, isArchived: false, level: 1 });
				this.$notify('success', `Category ${category.name} has been created.`);
			}).catch(() => {
				this.$notify('error', `Failed to add new category ${category.name}.`);
			}).finally(() => {
				this.$refs.form.reset();
				this.$emit('new');
			});
		},
	},
};
</script>

<style>

</style>
